// extracted by mini-css-extract-plugin
module.exports = {"font_btn":"FJWatermarkFont_font_btn__1hwu4","preview":"FJWatermarkFont_preview__1K4SX","dropdown":"FJWatermarkFont_dropdown__32Wp_"};